module.exports = __webpack_public_path__ + "img/xinlang-propa.365fe16e.png";